var $bca1931646cb2236$exports = {};
$bca1931646cb2236$exports = {
  "collapse": "\u6298\u53E0",
  "expand": "\u6269\u5C55"
};
export { $bca1931646cb2236$exports as default };